export default "/images/preview_bf_medium_rectangle.webp?2dc772ec2a987bd705fcb78d475e980d";